import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { addNewLookup } from "../../../redux/lookupSlice";

const SearchLookups = ({ selected, onAdded }) => {
  const dispatch = useDispatch();
  const [id, setId] = useState("");

  const addLookup = async (e) => {
    e.preventDefault();
    await dispatch(addNewLookup({ key: selected.id, value: id }));
    setId("");
    onAdded({ id: id, type: selected.id });
  };
  return (
    <form className="searchGroup" onSubmit={(e) => addLookup(e)}>
      <div className="inputField">
        <input
          type="text"
          required
          value={id}
          onChange={(e) => setId(e.target.value)}
          className="form-control"
        />
      </div>
      <button className="btn cta-primary">
        Add New{" "}
        <i className="ms-2">
          <Icon icon="ant-design:plus-outlined" />
        </i>
      </button>
    </form>
  );
};

export default SearchLookups;
